import { c as _c } from "react/compiler-runtime";
import { useStores } from 'modules/stores/hooks/use-stores';
import { Dispatch, SetStateAction } from 'react';
import { handle422Error } from 'shared/utils/parse-422-errors';
import { useStoresApi } from '../../hooks/use-stores-api';
import { StoreErrorsInterface, StoreInterface } from '../../types/stores-interface';
import { getStoreUpdateData } from '../utils/get-store-update-data';
import { useStore } from './use-store';
import { useStoreQuery } from './use-store-query';
export const useStoreEdit = t0 => {
  const $ = _c(6);
  const {
    setErrors
  } = t0;
  const {
    storeId
  } = useStoreQuery();
  const {
    data: store,
    mutate
  } = useStore(storeId);
  const {
    mutate: mutateList
  } = useStores();
  const {
    updateStore
  } = useStoresApi();
  let t1;
  if ($[0] !== mutate || $[1] !== mutateList || $[2] !== setErrors || $[3] !== store || $[4] !== updateStore) {
    const onSave = async data => {
      if (!store) {
        return;
      }
      ;
      try {
        const responseData = await updateStore(store.id, getStoreUpdateData({
          ...store,
          ...data
        }));
        await mutateList(prev => prev && {
          ...prev,
          items: prev.items.map(item => item.id === store.id ? responseData : item)
        }, false);
        await mutate(responseData, false);
      } catch (t2) {
        const e = t2;
        handle422Error(e, setErrors);
        throw e;
      }
    };
    t1 = {
      onSave
    };
    $[0] = mutate;
    $[1] = mutateList;
    $[2] = setErrors;
    $[3] = store;
    $[4] = updateStore;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};